import { render, staticRenderFns } from "./ListObjectBottomInfoBar.vue?vue&type=template&id=09ffb018"
import script from "./ListObjectBottomInfoBar.vue?vue&type=script&lang=js"
export * from "./ListObjectBottomInfoBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports